import { render, staticRenderFns } from "./SaitenList.vue?vue&type=template&id=5db9d775&scoped=true&"
import script from "./SaitenList.vue?vue&type=script&lang=ts&"
export * from "./SaitenList.vue?vue&type=script&lang=ts&"
import style0 from "./SaitenList.vue?vue&type=style&index=0&id=5db9d775&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db9d775",
  null
  
)

export default component.exports